var sPath = window.location.pathname;
var sPage = sPath.substring(sPath.lastIndexOf('/') + 1);

if(sPage == "asthma-test"){
    var progress = 0;
    var currentPageNumber = 1;
    var maxPageNumber = 3;
    var cntQuestionsAnswered = 0;
    var score = 0;
    var getResultsClicked = false;

    $('input').change(function(){
        var allChecked = $('input:checked').length == 10;

        progress=$('input:checked').length*10;
        document.getElementById("progress").style="width: "+progress+"%";

        if($('input:checked').length == 4 || $('input:checked').length == 7){
            document.getElementById("next-step-test").style = "display: block";
        }
        if(allChecked){
            document.getElementById("get-results").style = "display: block";
        }
    });

    document.getElementById("get-results").onclick = function() {
        if(!getResultsClicked){
            var value= document.getElementsByClassName('answer');
            for (var radio of value){
                if (radio.checked) {
                    if(radio.value=="JA"){
                        score++;
                    }
                }
            }
            document.getElementById("score").innerHTML = score.toString();
            document.getElementById("userScore").value = score.toString();
            document.getElementById("test-result").style = "display: block";
            document.getElementById("airq-scale").style = "display: block";
            document.getElementById("get-results").disabled = true;
            getResultsClicked=true;
        }
    }

    document.getElementById("next-step-test").onclick = function() {

        var elements = document.querySelectorAll(".q"+currentPageNumber);
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            document.getElementById(element.id).style = "display: none";
        }

        currentPageNumber++;
        document.getElementById("current-page-number").textContent=currentPageNumber.toString();

        var elements = document.querySelectorAll(".q"+currentPageNumber);
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            document.getElementById(element.id).style = "display: block";
            document.getElementById("next-step-test").style = "display: none";
        }
    }
}
